import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DialogRef } from 'angular2-modal';
import { URLSearchParams } from '@angular/http';
import { Router } from '@angular/router';

import { SharedClientService } from '../../../../../client/shared/services/shared-client.service';
import { SharedJobService } from '../../../../../client/shared/services/shared-job.service';

declare var $: any;


export class StatusModalComponent implements OnInit {

	public client: any;
	public state: any = {};
	public jobs: any = [];

	constructor(
		public dialog: DialogRef<any>,
		private router: Router,
		private sharedClientService: SharedClientService,
		private sharedJobService: SharedJobService) { }

	public ngOnInit() {
		$('body').addClass('status-modal-open');
		this.client = this.dialog.context.statusData.client;
		this.getJobs();
	}

	public closeModal(): void {
		$('body').removeClass('status-modal-open');
		$('body').removeClass('modal-open');

		window.location.href = `${process.env.CLIENT_APP_URL}/source`;

		this.dialog.close();
	}

	public onReactivateMyAccountClick(): void {
		if (this.client) {
			let data: any = {
				value: 'past-client|hot'
			};
			this.sharedClientService.updateStatus(this.client.id, data).subscribe(
				(res) => {
					this.state.success = true;
				}
			);
		}
	}

	private getJobs(): void {
		let params: URLSearchParams = new URLSearchParams();
		params.set('status', 'active');
		params.set('external', '0');
		this.sharedJobService.getClientJobs(this.client.id, params).subscribe(
			(jobs) => {
				this.jobs = jobs;
			}
		);
	}
static ctorParameters() { return [ { type: DialogRef }, { type: Router }, { type: SharedClientService }, { type: SharedJobService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/shared/navbar/client/modals/status/status-modal.component.ts